// extracted by mini-css-extract-plugin
module.exports = {"attribution":"LiveWindSourceAttribution_attribution__K2zb8","bomImage":"LiveWindSourceAttribution_bomImage__6JGS_"};